// extracted by mini-css-extract-plugin
module.exports = {" _key":"sitepen-site/Category","title":"Category-m__title__f52bc33Zgdy"};